import React, { useEffect, useState } from 'react';
import './ProductGallery.css';

function ProductGallery({ images, productName }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    setLightboxIndex(null);
  }, [images]);

  useEffect(() => {
    if (lightboxIndex === null) {
      document.body.style.overflow = '';
      return undefined;
    }

    document.body.style.overflow = 'hidden';

    function onKeyDown(event) {
      if (event.key === 'Escape') {
        setLightboxIndex(null);
      } else if (event.key === 'ArrowRight') {
        setLightboxIndex(current => (current + 1) % images.length);
      } else if (event.key === 'ArrowLeft') {
        setLightboxIndex(current => (current - 1 + images.length) % images.length);
      }
    }

    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [lightboxIndex, images.length]);

  const hasImages = images.length > 0;

  if (!hasImages) {
    return (
      <div className="product-gallery product-gallery--empty">
        <div className="product-gallery-placeholder">{productName}</div>
      </div>
    );
  }

  return (
    <>
      <div className="product-gallery" aria-label={`${productName} gallery`}>
        <div className="product-gallery-scroll">
          <div
            className={`product-gallery-grid${images.length === 1 ? ' product-gallery-grid--single' : ''}`}
          >
            {images.map((image, index) => (
              <button
                key={image.id || image.image_url}
                type="button"
                className="product-gallery-tile"
                onClick={() => setLightboxIndex(index)}
                aria-label={`Open image ${index + 1} fullscreen`}
              >
                <img
                  src={image.image_url}
                  alt={`${productName} view ${index + 1}`}
                  loading={index === 0 ? 'eager' : 'lazy'}
                  decoding="async"
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {lightboxIndex !== null && (
        <div
          className="product-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Fullscreen product image"
          onClick={() => setLightboxIndex(null)}
        >
          <button
            type="button"
            className="product-lightbox-close"
            aria-label="Close fullscreen view"
            onClick={() => setLightboxIndex(null)}
          >
            ×
          </button>

          {images.length > 1 && (
            <>
              <button
                type="button"
                className="product-lightbox-nav product-lightbox-nav--prev"
                aria-label="Previous image"
                onClick={event => {
                  event.stopPropagation();
                  setLightboxIndex(current => (current - 1 + images.length) % images.length);
                }}
              >
                ‹
              </button>
              <button
                type="button"
                className="product-lightbox-nav product-lightbox-nav--next"
                aria-label="Next image"
                onClick={event => {
                  event.stopPropagation();
                  setLightboxIndex(current => (current + 1) % images.length);
                }}
              >
                ›
              </button>
            </>
          )}

          <img
            src={images[lightboxIndex].image_url}
            alt={`${productName} fullscreen view ${lightboxIndex + 1}`}
            className="product-lightbox-image"
            onClick={event => event.stopPropagation()}
          />

          <p className="product-lightbox-count">
            {lightboxIndex + 1} / {images.length}
          </p>
        </div>
      )}
    </>
  );
}

export default ProductGallery;
